import React from 'react';
import NumberOfOTPs from './NumberOfOTPs';

const NumberOfOTPsContainer = ({ ...restProps }) => {
  return <NumberOfOTPs {...restProps} />;
};

export default React.memo(NumberOfOTPsContainer);
